/* Coaster Rizz — one endless collection page. Natalie, 2026-09-25:
 * "אני לא רוצה את זה אלא שהכל יהיה בעמוד הזה."
 *
 * TWO BUGS LIVED HERE, BOTH INVISIBLE, AND SHE FOUND THE SYMPTOM — "why do I
 * see only 24?" — after the thing had been reported as working. Both are
 * written down because both would be made again.
 *
 * 1. CRAFT LABELS THE FORWARD ARROW pagination__item--PREV. Measured on
 *    /collections/coasters 2026-09-26: the last pagination link is
 *    aria-label="Next page", href="?page=2", classes "pagination__item
 *    pagination__item--prev pagination__item-arrow". There is no --next on
 *    the page at all. The old code looked for a.pagination__item--next, found
 *    nothing, and stopped — after already hiding the pagination it was meant
 *    to replace. So the shelf offered 24 of 84 and no way to the rest.
 *    FIX: never read the pagination markup. The next page is this URL with
 *    page=N+1, carrying every filter and sort parameter across.
 *
 * 2. AN EMPTY DIV APPENDED TO THE COLLECTION CONTAINER IS display:none.
 *    Measured the same day by adding one and reading getComputedStyle: any
 *    bare div placed in .collection.page-width comes back "none", with or
 *    without aria-hidden. The sentinel the IntersectionObserver was watching
 *    therefore had zero height and never intersected anything.
 *    FIX: no sentinel. A scroll listener needs no element to exist, so no
 *    stylesheet can switch it off.
 */
(function () {
  'use strict';

  var busy = false;
  var done = false;
  var page = 1;
  var bound = false;

  function gridEl() {
    return document.getElementById('product-grid');
  }

  function urlForPage(n) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', String(n));
    return u.pathname + u.search;
  }

  function nearBottom() {
    return window.innerHeight + window.scrollY >
           document.documentElement.scrollHeight - 1400;
  }

  /* Craft fades cards in with an IntersectionObserver created before these
   * ones existed, so an appended card would sit at opacity 0 for ever. Strip
   * the classes and it renders plainly. */
  function undim(el) {
    var cls = ['scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen'];
    el.classList.remove.apply(el.classList, cls);
    var kids = el.querySelectorAll('.scroll-trigger');
    for (var i = 0; i < kids.length; i++) {
      kids[i].classList.remove.apply(kids[i].classList, cls);
    }
  }

  function pull() {
    if (busy || done) return;
    var grid = gridEl();
    if (!grid) return;
    busy = true;

    fetch(urlForPage(page + 1))
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { done = true; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelectorAll('#product-grid > li');
        if (!incoming.length) { done = true; return; }
        for (var i = 0; i < incoming.length; i++) {
          var card = document.importNode(incoming[i], true);
          undim(card);
          grid.appendChild(card);
        }
        page += 1;
      })
      .catch(function () { done = true; })
      .then(function () {
        busy = false;
        /* the page may still be short enough to need the one after it */
        if (!done && nearBottom()) pull();
      });
  }

  function onScroll() {
    if (nearBottom()) pull();
  }

  function setup() {
    if (!gridEl()) return;

    busy = false;
    done = false;
    page = parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1;

    var wrap = document.querySelector('.pagination-wrapper');
    if (wrap) wrap.style.display = 'none';

    if (!bound) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      bound = true;
    }
    onScroll();
  }

  /* Craft replaces the whole grid container when a filter or sort changes,
   * which resets which page we are on. */
  function watch() {
    var host = document.getElementById('ProductGridContainer');
    if (!host) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(setup, 150);
    }).observe(host, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); watch(); });
  } else {
    setup();
    watch();
  }
})();
